module.exports = __webpack_public_path__ + "static/media/support.e7856704.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/onboardig/svg/support.svg
// module id = 3843
// module chunks = 0